import { memo, type FC } from 'react';
import { Typography, Tooltip, Flex } from 'antd';
import { ClockCircleOutlined, RightOutlined } from '@ant-design/icons';

import styles from './styles.module.scss';

import type { TStatusNote } from './types';

const { Text } = Typography;

type StatusNoteItemProps = TStatusNote & {
  valueFormatter: (value: number) => string;
};

const StatusNoteItem: FC<StatusNoteItemProps> = ({
  label,
  value,
  valueFormatter,
  details,
  onItemClick,
}) => {
  const hasDetails = details && details.length > 0;

  const tooltipContent = hasDetails ? (
    <Flex vertical className={styles['tooltip-content-wrapper']}>
      <Text className={styles['tooltip-title']}>{label}</Text>
      <Flex vertical className={styles['tooltip-list']}>
        {details?.map((item) => (
          <Flex
            key={item.patientId}
            className={styles['tooltip-item']}
            onClick={() => onItemClick?.(item.patientId)}
            align="center"
            gap={8}
          >
            <Text className={styles['patient-name']}>{item.patientName}</Text>
            <Flex
              align="center"
              gap={4}
              className={styles['date-time-wrapper']}
            >
              <ClockCircleOutlined className={styles['clock-icon']} />
              <Text className={styles['due-date']}>{item.dueDateTime}</Text>
            </Flex>
            <RightOutlined className={styles['chevron-icon']} />
          </Flex>
        ))}
      </Flex>
    </Flex>
  ) : null;

  const noteValueElement = (
    <div className={styles['status-note']}>{valueFormatter(value)}</div>
  );

  return (
    <div className={styles['status-note-row']}>
      <Text className={styles['status-note-label']}>{label}</Text>
      {hasDetails ? (
        <Tooltip
          title={tooltipContent}
          classNames={{ root: styles['calls-due-tooltip'] }}
          placement="bottomRight"
          trigger={['click', 'hover']}
          color="white"
        >
          {noteValueElement}
        </Tooltip>
      ) : (
        noteValueElement
      )}
    </div>
  );
};

export default memo(StatusNoteItem);
